
import { Options, Vue }    from 'vue-class-component';
import MultiImageDisplayCard  from '../components/shared/multi-image-display-card.vue';
import {
  ConfigurableAddonGroup,
  CpqCartProductJson,
} from '../libs/cpq-builder/cpq-json.interface';
import { salesqueze } from '../libs/salesqueze-sdk-browser';
import AddonCard from '@/components/shared/addon-card.vue';
import { chain, keyBy, mapValues } from 'lodash'

@Options({
  components: {
    AddonCard,
    MultiImageDisplayCard
  },
  data() {
    return {
      items: this.items
    }
  },
  watch: {
    items:{
      handler:function(newVal) {
        this.$store.commit('setCurbs', newVal);
      },
      deep:true
    }
  }
})
export default class Curb extends Vue {
  items: { key: string; title: string; attributes: ({ key: string; value: string; } | { key: string; value: number; })[]; price: string; media: any; }[];
  mounted(){

    const productRes = this.$store.state.curbs || this.$store.state.responseCurbs.map(x=> ({
      id: x._id,
      key: x.key,
      title: x.name,
      description: x.description,
      attributes: chain(x.propertyAttributes).keyBy('key').mapValues('value').value(),
      price: x.priceUnit ? `${(x.estimatedPrice.retailPriceWithDiscount || x.estimatedPrice.retailPrice).toFixed(2)} € / ${x.priceUnit}` : `${(x.estimatedPrice.retailPriceWithDiscount || x.estimatedPrice.retailPrice).toFixed(2)} €`,
      priceWithoutDiscount: x.priceUnit ? `${x.estimatedPrice.retailPrice.toFixed(2)} € / ${x.priceUnit}` : `${x.estimatedPrice.retailPrice.toFixed(2)} €`,
      discount: x.estimatedPrice.retailPriceDiscount?.value > 0 ? true : false,
      thumbnail: x.metadata.thumbnail,
      priceUnit: x.priceUnit
    }));

    this.items = productRes;
  }
}
